import './App.css';
import { useNavigate } from 'react-router-dom';
import { Message } from './components';
import { useEffect, useState } from 'react';
import Icon, { MenuOutlined,  PlusCircleFilled , MinusCircleFilled,CloseSquareOutlined, EditOutlined, ArrowLeftOutlined, CheckCircleFilled} from '@ant-design/icons';
import { Button, Checkbox, Drawer, Form, Input, Menu, Popconfirm, Select, Switch } from 'antd';
import { menu } from './Dash';
import { addCausal, checkLogIn, getCausal, getEnterpriseInfo, messageGeneral, removeCausal } from './Functions';
import { useForm } from 'antd/es/form/Form';



function Reasons() {
  const navigate = useNavigate();
  const [addReasons, setAddReasons]   = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage]         = useState('');
  const [openDrawer, setOpenDrawer]   = useState(false)
  const [reasons, setReasons]         = useState([])
  const [form_] = useForm();
  const [context, start ]                         = messageGeneral();


  const [edit, setEdit] = useState(null)
  useEffect(()=>{
    if( edit == null) return;
  /*   value="spent">Uscita</Select.Option>
                  <Select.Option value="cashed">Entrata</Select.Option>
                  <Select.Option value="neutral">Neutra</Select.Option> */
    form_.setFieldValue('name',  edit.name);
    form_.setFieldValue('type',  edit.movementType);

    form_.setFieldValue('fornitore',        edit.mandatorySupplier);
    form_.setFieldValue('imponibile',       edit.mandatoryAmount);
    form_.setFieldValue('totaleiva',        edit.mandatoryAmountTaxable);
    form_.setFieldValue('dataDoc',          edit.mandatoryDocumentDate);
    form_.setFieldValue('nota',             edit.mandatorySupplier);
    form_.setFieldValue('numeroDocumento',  edit.mandatoryBillNumber);
    //form.setFieldValue('store', edit.pointOfSale.token);
  },[edit])

  async function callReasons () {
    setReasons(await getCausal());
  }

    useEffect(() => {
      if(checkLogIn() == null ) navigate('/');
      if( getEnterpriseInfo().role == 'operator') navigate('/movements')
      callReasons();
    },[])

    useEffect(()=>{
      callReasons();
    },[addReasons])

  async function register (values){
    try{
      const { name, type, dataDoc, fornitore, imponibile, nota, numeroDocumento, totaleiva } = values;
      const add = await addCausal(name, type , edit ? edit.token : null, dataDoc, fornitore, imponibile, nota, numeroDocumento, totaleiva)
      if( add ){
        if(edit){
          await callReasons()
          setEdit(null);
          setAddReasons(false)
          start('Causale modificata');
          form_.resetFields();
          return;
        }
        start('Causale aggiunta');
        form_.resetFields();
      }
    }catch( err ){
      console.log(err);
    }
  }


  const Conferma = ( child, token ) => {
    
    async function remove() {
     const r = await removeCausal(token);
     if( r ){
      start('Causale eliminata')
      setReasons(await getCausal());
     }
    }
  
    return (
      <Popconfirm
        title="Sei sicuro di voler eliminare?"
        onConfirm={()=> remove()}
        okText="Sì"
        cancelText="No"
      >
        { child }
      </Popconfirm>
    );
  };

  return (
    <div className="center bg-color-primary all-viewport">
      {context}
      
      {
         Message( message, openMessage, ()=> setOpenMessage(false))
      }
      <div onClick={()=> setOpenDrawer(true)} style={{position:'fixed', top: '10px', left:'10px'}}>
        <MenuOutlined style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
      </div>
      <div style={{position:'fixed', top: '10px', right:'10px'}}>
        {
          addReasons 
          ?
          < ArrowLeftOutlined onClick={() => setAddReasons(false)} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
          :
          < PlusCircleFilled onClick={() =>  setAddReasons(true)} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />
        }
      </div>
      <div className='table-smart' style={{position:'fixed', left:0, top:0,  height:'100%', width:'10%', backgroundColor:'white', zIndex: 20}}>
        {
           menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
                className='center'
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'15px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )}
      </div>
   <Drawer
        className='bg-color-secondary'
        placement='left'
        open={openDrawer}
        onClose={()=> setOpenDrawer(false)}
      >
        <div style={{height:'100%', width: '100%', overflowY: 'auto'}}>
          {
            menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'20px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )
          }
        </div>
      </Drawer> 
       {
       addReasons
       ?   
        <Form
            form={form_}
            onFinish={register}
          >
            <div  className='center text-style' style={{ marginBottom:'10px'}}>{ edit ? 'Modifica causale' : 'Aggiungi causale' }</div>
            <Form.Item
                name="name"
                rules={[{ required: true, message: 'Inserire causale' }]}
              >
                <Input className='input-style' placeholder='Nome causale'/>
            </Form.Item>
            <Form.Item
                name="type"
                rules={[{ required: true, message: 'seleziona tipo causale' }]}
              >
                <Select  className='input-style' placeholder='Tipo movimento'>
                  <Select.Option value="spent">Uscita</Select.Option>
                  <Select.Option value="cashed">Entrata</Select.Option>
                  <Select.Option value="neutral">Neutra</Select.Option>
                </Select>
            </Form.Item>
            <div  className='center text-style' style={{ marginBottom:'10px', fontSize:'20px'}}>Campi obbligatori</div>
            <div className='center' style={{flexDirection:'column', alignItems:'start', backgroundColor:''}}>
              <div className='center' style={{width:'90%'}}>
                <Form.Item valuePropName="checked" name='fornitore' label='Fornitore' className='center' style={{width:'50%', justifyContent:'end'}}>
                  <Checkbox/>
                </Form.Item>
                <Form.Item valuePropName="checked" name='imponibile' label='Imponibile' className='center'style={{width:'50%', justifyContent:'end'}}>
                  <Checkbox/>
                </Form.Item>
              </div>

              <div className='center'style={{justifyContent:'space-around', width:'90%'}}>
                <Form.Item valuePropName="checked" name='totaleiva' label='Totale IVA' className='center' style={{width:'50%', justifyContent:'end'}}>
                  <Checkbox/>
                </Form.Item>
                <Form.Item valuePropName="checked"  name='numeroDocumento' label='Numero doc.'className='center' style={{width:'50%', justifyContent:'end'}}>
                  <Checkbox/>
                </Form.Item>
              </div>

              <div className='center'style={{justifyContent:'space-around', width:'90%'}}>
                <Form.Item  valuePropName="checked" name='dataDoc' label='Data doc.'className='center' style={{width:'50%', justifyContent:'end'}}>
                  <Checkbox/>
                </Form.Item>
                <Form.Item valuePropName="checked" name='nota' label='Nota'className='center' style={{width:'50%', justifyContent:'end'}}>
                  <Checkbox/>
                </Form.Item>
              </div>

            </div>
            <Button
              className='input-style color-one'
              type="primary" 
              htmlType="submit">
              { edit ? 'Modifica' : 'Aggiungi' }</Button>
          </Form>
          : <div  style={{ height:'100%', width:'100%', backgroundColor:''}} className='center'> 
            <div className='center' style={{ height:'70%', width:'80%', backgroundColor:'', flexDirection:'column'}}>
              <div onClick={()=> console.log(reasons)} className='center text-style' style={{ marginBottom:'10px'}}> Lista causali </div>
              <div style={{width:'100%', maxWidth:'500px', height: '100%', overflowY:'auto', backgroundColor:'', marginTop:'20px'}}>
                {
                  reasons.map((s, index) => {
                   return (
                    <div className='center' style={{ padding:'10px', textAlign:'center', backgroundColor: (index %2 == 0) ? 'rgba(52, 121, 57, 0.5)' : 'rgba(52, 121, 57, 0.2)'  }}>
                          <div className='center' style={{ width:'100%', height:'40px', justifyContent:'flex-start'}} key={index}> { s.name + ' '+(s.movementType == 'neutral' ? '(Neutro)' : s.movementType == 'cashed' ? '(Entrata)' : '(Uscita)')  } </div>
                          { Conferma(<CloseSquareOutlined  style={{color:'red', fontSize:'25px'}} />, s.token) }
                           <div style={{width:'20px'}}/>
                          { <EditOutlined onClick={()=>{
                            setEdit(s)
                            setAddReasons(true);
                          }}  style={{color:'rgba(52, 121, 57, 1)', fontSize:'25px', }} /> }
                    </div>
                        )
                  })
                }
              </div>
            </div>

          </div>
        }

    </div>
  );
}

export default Reasons;
